// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Lens_At = require("../Data.Lens.At/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Internal_Market = require("../Data.Lens.Internal.Market/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Lens_Prism_Maybe = require("../Data.Lens.Prism.Maybe/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Class_GraphRep = require("../Lunarbox.Data.Class.GraphRep/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Expression_Optimize = require("../Lunarbox.Data.Dataflow.Expression.Optimize/index.js");
var Lunarbox_Data_Editor_DataflowFunction = require("../Lunarbox.Data.Editor.DataflowFunction/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Location = require("../Lunarbox.Data.Editor.Location/index.js");
var Lunarbox_Data_Editor_Node = require("../Lunarbox.Data.Editor.Node/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_NodeGroup = require("../Lunarbox.Data.Editor.NodeGroup/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var Project = function (x) {
    return x;
};
var newtypeProject = new Data_Newtype.Newtype(function (n) {
    return n;
}, Project);
var graphRepProject = new Lunarbox_Data_Class_GraphRep.GraphRep(function (v) {
    return Lunarbox_Data_Class_GraphRep.toGraph(Lunarbox_Data_Class_GraphRep.graphRepDependencyMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Lunarbox_Data_Editor_DataflowFunction.dependencyDataflowFunction))(v.functions);
});
var encodeJsonProject = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    var functions$prime = Data_Filterable.filter(Data_Filterable.filterableMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(Lunarbox_Data_Editor_DataflowFunction["_VisualFunction"](Data_Lens_Internal_Market.choiceMarket)))(v.functions);
    return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJson)("main")(Data_Argonaut_Encode_Class.encodeJson(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)(v.main)))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJson)("functions")(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)(Lunarbox_Data_Editor_DataflowFunction.encodeJsonDataflowFunction))(functions$prime)))(Data_Argonaut_Core.jsonEmptyObject));
});
var decodeJsonProject = Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName)(Lunarbox_Data_Editor_DataflowFunction.decodeJsonDataflowFunction))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "main";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "functions";
}))()())();
var createEmptyFunction = function (id) {
    return Lunarbox_Data_Editor_DataflowFunction.VisualFunction.create({
        inputs: Data_Monoid.mempty(Data_List_Types.monoidList),
        nodes: Data_Map_Internal.singleton(id)(new Lunarbox_Data_Editor_Node.OutputNode(Data_Maybe.Nothing.value)),
        output: id
    });
};
var emptyProject = function (id) {
    var $$function = createEmptyFunction(id);
    return {
        main: "main",
        functions: Data_Map_Internal.singleton("main")($$function)
    };
};
var compileProject = function (v) {
    var graph = Lunarbox_Data_Class_GraphRep.toGraph(graphRepProject)(v);
    var sorted = Lunarbox_Data_Graph.topologicalSort(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(graph);
    var compileFunction = function (name) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Data_Functor.functorFn)(Data_Tuple.Tuple.create(name))(Lunarbox_Data_Dataflow_Expression.Expression.create(new Lunarbox_Data_Editor_Location.AtFunction(name))))(Data_Functor.map(Lunarbox_Data_Dataflow_Expression.functorExpression)(Lunarbox_Data_Editor_Location.InsideFunction.create(name))))(Lunarbox_Data_Editor_DataflowFunction.compileDataflowFunction))(Lunarbox_Data_Graph.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(graph));
    };
    return Lunarbox_Data_Dataflow_Expression_Optimize.inline(Lunarbox_Data_Editor_Location.eqLocation)(Data_Foldable.foldr(Data_List_Types.foldableList)(function (v1) {
        return function (body) {
            var name = Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v1.value0));
            var location = new Lunarbox_Data_Editor_Location.AtFunctionDeclaration(v1.value0);
            var isRecursive = Lunarbox_Data_Dataflow_Expression.isReferenced(name)(v1.value1);
            var value$prime = (function () {
                if (isRecursive) {
                    return new Lunarbox_Data_Dataflow_Expression.FixPoint(new Lunarbox_Data_Editor_Location.FixpointOperator(v1.value0), name, v1.value1);
                };
                if (Data_Boolean.otherwise) {
                    return v1.value1;
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Editor.Project (line 85, column 15 - line 90, column 36): " + [  ]);
            })();
            return new Lunarbox_Data_Dataflow_Expression.Let(location, name, value$prime, body);
        };
    })(Lunarbox_Data_Dataflow_Expression.Variable.create(Lunarbox_Data_Editor_Location.UnknownLocation.value)(Lunarbox_Data_Dataflow_Expression.VarName(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.main))))(Data_List.catMaybes(Data_Functor.map(Data_List_Types.functorList)(compileFunction)(sorted))));
};
var _ProjectMain = function (dictStrong) {
    var $22 = Lunarbox_Data_Lens.newtypeIso(newtypeProject)(dictStrong);
    var $23 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "main";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($24) {
        return $22($23($24));
    };
};
var _ProjectFunctions = function (dictStrong) {
    var $25 = Lunarbox_Data_Lens.newtypeIso(newtypeProject)(dictStrong);
    var $26 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "functions";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($27) {
        return $25($26($27));
    };
};
var _atProjectFunction = function (name) {
    return function (dictWander) {
        var $28 = _ProjectFunctions(dictWander.Strong0());
        var $29 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(name)(dictWander.Strong0());
        return function ($30) {
            return $28($29($30));
        };
    };
};
var createFunction = function (name) {
    return function (outputId) {
        return Data_Lens_Setter.set(_atProjectFunction(name)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Just.create(createEmptyFunction(outputId)));
    };
};
var _atProjectNodeGroup = function (name) {
    return function (dictWander) {
        var $31 = _ProjectFunctions(dictWander.Strong0());
        var $32 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(name)(dictWander.Strong0());
        var $33 = Data_Lens_Prism_Maybe["_Just"](dictWander.Choice1());
        var $34 = Lunarbox_Data_Editor_DataflowFunction["_VisualFunction"](dictWander.Choice1());
        return function ($35) {
            return $31($32($33($34($35))));
        };
    };
};
var _atProjectNode = function (name) {
    return function (id) {
        return function (dictWander) {
            var $36 = _atProjectNodeGroup(name)(dictWander);
            var $37 = Lunarbox_Data_Editor_NodeGroup["_NodeGroupNodes"](dictWander.Strong0());
            var $38 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_Node_NodeId.ordNodeId))(id)(dictWander.Strong0());
            return function ($39) {
                return $36($37($38($39)));
            };
        };
    };
};
var _projectNodeGroup = function (name) {
    return function (dictWander) {
        var $40 = _ProjectFunctions(dictWander.Strong0());
        var $41 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(name)(dictWander.Strong0());
        var $42 = Data_Lens_Prism_Maybe["_Just"](dictWander.Choice1());
        var $43 = Lunarbox_Data_Editor_DataflowFunction["_VisualFunction"](dictWander.Choice1());
        return function ($44) {
            return $40($41($42($43($44))));
        };
    };
};
var getFunctions = function (dictUnfoldable) {
    var $45 = Data_Set.toUnfoldable(dictUnfoldable);
    var $46 = Data_Lens_Getter.view(_ProjectFunctions(Data_Lens_Internal_Forget.strongForget));
    return function ($47) {
        return $45(Data_Map.keys($46($47)));
    };
};
module.exports = {
    Project: Project,
    compileProject: compileProject,
    createEmptyFunction: createEmptyFunction,
    emptyProject: emptyProject,
    createFunction: createFunction,
    getFunctions: getFunctions,
    "_atProjectFunction": _atProjectFunction,
    "_atProjectNode": _atProjectNode,
    "_ProjectFunctions": _ProjectFunctions,
    "_ProjectMain": _ProjectMain,
    "_projectNodeGroup": _projectNodeGroup,
    newtypeProject: newtypeProject,
    encodeJsonProject: encodeJsonProject,
    decodeJsonProject: decodeJsonProject,
    graphRepProject: graphRepProject
};
